<section class="game-hero">
  <img
    [src]="game().heroImageUrl"
    [alt]="game().name"
    class="game-hero__bg"
    fetchpriority="high"
  />
  <div class="game-hero__overlay"></div>
  <div class="game-hero__content">
    <img
      [src]="game().heroLogoUrl"
      [alt]="game().name + ' logo'"
      class="game-hero__logo"
      loading="eager"
    />
    <h1 class="game-hero__name visually-hidden">{{ game().name }}</h1>
    <p class="game-hero__tagline">{{ game().tagline }}</p>
  </div>
</section>
